import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import Button from "@/components/button.vue"
  import Options from "@/components/inputs/options.vue"
  import ContentModal from "@/components/modals/content.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {ref} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'enumerations',
  props: /*@__PURE__*/_mergeModels({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "selection": {
    default: null,
    required: true,
    type: Array<string>
  },
    "selectionModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:selection"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit
  const selection = _useModel(__props, "selection")
  
  const display = ref<boolean>(false)

  function apply() {
    display.value = false
    emits("update")
  }

  function displaySelection(): string {
    let output = ""
    if (!selection.value || !selection.value.length) {
      return output
    }
    for (const [index, enumeration] of selection.value.entries()) {
      if (index == 0) {
        output += enumeration
      } else {
        output += `, ${enumeration}`
      }
    }
    return output
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(TextInput, {
        value: displaySelection(),
        title: __props.title,
        readOnly: __props.readOnly,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (display.value = true))
      }, null, 8, ["value", "title", "readOnly"]),
      (display.value)
        ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(Options, {
                selection: selection.value,
                "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((selection).value = $event)),
                options: __props.options,
                readOnly: __props.readOnly
              }, null, 8, ["selection", "options", "readOnly"]),
              (__props.readOnly)
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    title: "Close",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (display.value = false))
                  }))
                : (_openBlock(), _createBlock(Button, {
                    key: 1,
                    title: "Apply",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (apply()))
                  }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})